let $tableNavItems;
let $compareTables;
let $compareToggle;

let $templateCalculator;
let $sendForm;
let $sendFormInputs;

let $sendCalcType;

let $SMPSetValue;

$(document).ready(function ($) {
  $tableNavItems = $('.js-table-nav-item');
  $compareTables = $('.js-compare-table');
  $compareToggle = $('.js-compare-toggle');

  $templateCalculator = $('.js-template-calculator');
  $sendForm = $('.js-sendmp-form');
  $sendFormInputs = $('.js-sendmp-form input');
  $sendCalcType = $('.js-sendmp-calc-type');


  // Switch class
  $SMPSetValue = $('.js-smp-set-value');

    $tableNavItems.on('click', function () {
        $tableNavItems.removeClass('is-active');
        $compareTables.removeClass('is-active');
        $(this).addClass('is-active');

        let index = $(this).index();
        $compareTables.eq(index).addClass('is-active');
    });

    $compareToggle.on('click', function () {
        $(this).parent().prev().toggleClass('is-closed');

        $(this).toggleClass('is-more');
        $(this).toggleClass('is-less');

    });

  if ($templateCalculator.length) {
    const calculator = new SendCalculator();
    calculator.init();
  }
});

  class SendCalculator {

    // Debug mode
    debug = true;

    // Set variables
    typeId = 0;
    destinationSlug = '';
    transporters = [];

    rangeSliderIndex = 0;
    rangeStepIndex = 0;
    subscriptionOrder = [];

    $destinationSelects = [];
    $sliders = [];
    $sliderInputs = [];
    $destinationCountContainer = [];
    $destinationCountSelect = [];
    $configOptions = [];
    $configOptionsInputs = [];
    $rates = [];
    $compareTables = [];

    $toggleFee = [];
    $toggleRates = [];

    rangeSubscription = 0;
    destinationCountSubscription = 0;
    highestOptionSubscriptionIndex = 0;

    $sliderAdd = [];
    $sliderMinus = [];


    // Get initial values
    init() {
      // Get elements
      this.$destinationSelects = $('.js-smp-destination');
      this.$sliders = $('.js-smp-range-slider');
      this.$sliderInputs = $('.js-smp-range-slider-input');
      this.$destinationCountContainer = $('.js-destination-count');
      this.$destinationCountSelect = $('.js-destination-count-select');
      this.$configOptions = $('.js-smp-options-container');
      this.$configOptionsInputs = $('.js-config-options');
      this.$rates = $('.js-rates');
      this.$toggleFee = $('.js-smp-toggle-fee');
      this.$toggleRates = $('.js-smp-toggle-rate');
      this.$compareTables = $('.js-compare-table');

      this.$sliderAdd = $('.js-smp-range-add');
      this.$sliderMinus = $('.js-smp-range-min');

      this.setSubscriptionOrder();


      // Set initial values
      this.setTypeId();
      this.setDestinationSlug();
      this.setRangeSliderIndex();
      this.setTransporters();
      this.setRangeStepIndex();

      this.setDestinationCountSubscription();
      this.setHighestOptionSubscription();


      // Add event listeners
      this.addTypeChangeListener();
      this.addDestinationChangeListener();
      this.addTransportChangeListener();
      this.addSliderChangeListener();
      this.addDestinationCountChangeListener();
      this.addConfigOptionChangeListener();
      this.addToggleFeeListener();

      // Update fields
      this.updateFields();
      this.updateSubscription(true);
    }

    /**
     * [
     *     {
     *         "id": 2692,
     *         "title": "Start"
     *     },
     *     {
     *         "id": 2690,
     *         "title": "Standaard"
     *     },
     *     {
     *         "id": 2701,
     *         "title": "Premium"
     *     },
     *     {
     *         "id": 2699,
     *         "title": "Plus"
     *     },
     *     {
     *         "id": 2706,
     *         "title": "Max"
     *     }
     * ]
     */
    setSubscriptionOrder() {
      //Make an array with only the ids
      this.subscriptionOrder = subscriptionOptions.map((subscription) => {
        return subscription.id;
      });
    }

    /**
     * The type is on the top level. so we can set it directly
     */
    setTypeId() {
      this.typeId = $('input[name="type"]:checked').val();
    }

    /**
     * Destination is dependent on the type, so we need to set it based on the type
     */
    setDestinationSlug() {
      let name = 'destination-' + this.typeId;

      // Get value from select field
      this.destinationSlug = $('select[name="' + name + '"]').val();
    }

    setTransporters() {
      let $transporter = $('.js-smp-transporters:checked');

      //empty array
      this.transporters = [];

      $transporter.each((index, transporter) => {
        this.transporters.push($(transporter).val());
      });
    }

    setRangeSliderIndex() {


      // loop trough sliders and return index of the first slider that contains the type and destination
      this.$sliders.each((index, slider) => {
        let types = $(slider).data('types');
        let destinations = $(slider).data('destinations');

        // check if values are undefined
        if (typeof types === 'undefined' || typeof destinations === 'undefined') {
          if (this.debug) {
          }
          return false;
        }

        // type and destination are strings seperated by ','. We split each and check if the current type and destination are in the array
        let typeArray = types.toString().split(',');
        let destinationArray = destinations.toString().split(',');

        if(this.debug) {
          //
          //
          // // Check if type is in array
          //
          // // Check if destination is in array
        }


        // check if the current type and destination are in the array
        if (typeArray.includes(this.typeId) && destinationArray.includes(this.destinationSlug)) {
          this.rangeSliderIndex = index;
        }
      });
    }

    setRangeStepIndex() {
      let $input = this.$sliders.eq(this.rangeSliderIndex).find('.js-smp-range-slider-input');
      this.rangeStepIndex = $input.val();
    }


    setDestinationCountSubscription() {
      let $select = $('.js-destination-count-select-' + this.typeId);
      this.destinationCountSubscription = $select.val();
    }

    addTypeChangeListener() {
      $(document).on('change', '.js-smp-type', () => {
        this.setTypeId();
        this.setDestinationSlug();
        this.setRangeSliderIndex();

        this.updateFields();
      });

      // This change event is for the select field and changes the radio button.
      $(document).on('change', '.js-smp-type--select', (event) => {
        $('.js-smp-type').filter(function(){
          if ($(this).val() == $(event.target).val()) {
            return $(this).prop('checked', true);
          }
        });

        this.setTypeId();
        this.setDestinationSlug();
        this.setRangeSliderIndex();

        this.updateFields();
      });
    }

    addDestinationChangeListener() {
      $(document).on('change', '.js-smp-destination', () => {
        this.setDestinationSlug();
        this.setRangeSliderIndex();

        this.updateFields();
      });
    }

    addTransportChangeListener() {
      $(document).on('change', '.js-smp-transporters', () => {
        this.setTransporters();
        this.updateRates();
      });
    }

    addConfigOptionChangeListener() {
      $(document).on('change', '.js-smp-options', () => {
        this.setHighestOptionSubscription();
        this.updateSubscription();
      });
    }

    addSliderChangeListener() {
      let sendCalculator = this;

      this.$sliderInputs.on('input', function() {
        sendCalculator.setSubscription($(this));
      });

      this.$sliderAdd.on('click', function(e) {
        e.preventDefault();
        let $input = $(this).prev().find('.js-smp-range-slider-input');

        let value = parseInt($input.val());
        value++;
        if (value > parseInt($input.attr('max'))) {
          value = parseInt($input.attr('max'));
        }

        $input.val(value);

        // trigger input event
        $input.trigger('input');
      });

      this.$sliderMinus.on('click', function(e) {
        e.preventDefault();
        let $input = $(this).next().find('.js-smp-range-slider-input');

        let value = parseInt($input.val());
        value--;

        // Check if value is lower than min value on input
        if (value < parseInt($input.attr('min'))) {
          value = parseInt($input.attr('min'));
        }

        $input.val(value);

        $input.trigger('input');
      });
    }

    addDestinationCountChangeListener() {

      $(document).on('change', '.js-destination-count-select', () => {
        this.setDestinationCountSubscription();
        this.updateSubscription();
      });
    }

    addToggleFeeListener() {
      $(document).on('change', '.js-smp-toggle-fee', () => {
        this.$toggleRates.toggleClass('show-fees');
      });
    }

    setSubscription($sliderInput) {
      let $targetRangeSlider = $sliderInput.closest('.js-smp-range-slider');
      let $targetRangeSliderFill= $targetRangeSlider.find('.js-smp-range-slider-fill');
      let $title = $targetRangeSlider.find('.js-smp-range-slider-title');

      $targetRangeSlider.find('.js-smp-range-slider-step-label').removeClass('is-current');
      let $items = $targetRangeSlider.find('.js-smp-range-slider-step-label[data-index=' + $sliderInput.val() + ']');
      $items.addClass('is-current');

      let $first = $items.first();

      $title.text($first.attr('data-label'));


      let maxSteps = $targetRangeSliderFill.attr('data-max-steps');
      let right = 'calc(100% - ' + ($sliderInput.val() / maxSteps * 100) + '%)';
      $targetRangeSliderFill.css('right', right);

      this.rangeSubscription = $first.attr('data-min-subscription');
      this.rangeStepIndex = $sliderInput.val();

      // console.log('Slider changed to: ', $sliderInput.val());
      this.updateRates();
      this.updateSubscription();
    }

    setHighestOptionSubscription() {
      this.highestOptionSubscriptionIndex = 0;
      let $options = $('.js-smp-options-' + this.typeId +':checked');
      $options.each((index, option) => {
        let optionId = $(option).val();
        let optionIndex = this.subscriptionOrder.indexOf(parseInt(optionId));

        if (optionIndex > this.highestOptionSubscriptionIndex) {
          this.highestOptionSubscriptionIndex = optionIndex;
        }
      });
    }

    /**
     * Determine which fields to show based on type, destination, and range
     */
    updateFields() {
      // hide fields
      this.$destinationSelects.addClass('is-hidden');
      this.$sliders.addClass('is-hidden');
      this.$destinationCountContainer.addClass('is-hidden');
      this.$configOptions.addClass('is-hidden');
      this.$rates.addClass('is-hidden');

      // show destination based on type (data-type attr)
      $('.js-smp-destination[data-type="' + this.typeId + '"]').removeClass('is-hidden');
      $('.js-destination-count[data-type="' + this.typeId + '"]').removeClass('is-hidden');
      $('.js-smp-options-container[data-type="' + this.typeId + '"]').removeClass('is-hidden');
      this.$sliders.eq(this.rangeSliderIndex).removeClass('is-hidden');


      this.updateRates();
    }

    updateRates() {

      this.$rates.addClass('is-hidden');

      this.transporters.forEach((transporter) => {
        let classString = '.js-rates-' + this.typeId + '-' + this.destinationSlug + '-' + transporter + '-' + this.rangeStepIndex;

        $(classString).removeClass('is-hidden');
      });
    }

    updateSubscription(first = false) {
      if (first) {
        let $activeSlider = $('.js-smp-range-slider').not('.is-hidden');
        let activeSliderVal = $activeSlider.find('.js-smp-range-slider-input').val();
        this.rangeSubscription = $activeSlider.find('.js-smp-range-slider-step-label[data-index="' + activeSliderVal + '"]').attr('data-min-subscription');

      }

      // Get subscription index based on the sliderPosition(value)
      let rangeIndex = this.subscriptionOrder.indexOf(parseInt(this.rangeSubscription));

      // get value from select
      let destinationIndex = this.subscriptionOrder.indexOf(parseInt(this.destinationCountSubscription));

      // get highest index
      let highestIndex = Math.max(rangeIndex, destinationIndex, this.highestOptionSubscriptionIndex);

      // get id from subscriptionOrder
      let subscriptionId = this.subscriptionOrder[highestIndex];

      // remove all classes starting with 'js-show-' from .js-compare-table
      this.$compareTables.removeClass(function(index, className) {
        return (className.match(/(^|\s)js-show-\S+/g) || []).join(' ');
      });

      // add class to show table
      this.$compareTables.addClass('js-show-' + subscriptionOptions[highestIndex].slug);
      $('.js-smp-subscription').addClass('is-hidden');

      // show subscription target based on type (data-type attr)
      $('.js-smp-subscription[data-subscription="' + subscriptionId + '"]').removeClass('is-hidden');
    }

  }
